import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { X_HOHR_CAPTCHA_TOKEN } from '@app/core/constants/recaptcha.constant';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { SignBatch } from '../models/sign-document-batch.types';

@Injectable({ providedIn: 'root' })
export class SignDocumentBatchService {
  private readonly http = inject(HttpClient);

  private readonly baseUrl = `${environment.url.api}/document`;

  getSignBatch(documentBatchId: string): Observable<SignBatch> {
    return this.http.get<SignBatch>(`${this.baseUrl}/sign-batch/${documentBatchId}`);
  }

  startSigning(documentBatchId: string, captchaToken: string): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/sign-batch/${documentBatchId}/sign/start`, null, {
      headers: { [X_HOHR_CAPTCHA_TOKEN]: captchaToken },
    });
  }

  verifySigning(documentBatchId: string, verificationCode: string): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/sign-batch/${documentBatchId}/sign/verify`, { verificationCode });
  }
}
